import { Method } from 'axios';
import { APICallV4 } from 'reactApp/api/APICall';

export class SendPaymentLetterAPICall extends APICallV4 {
    _method = 'billing/letter/send';
    _type: Method = 'post';
}
